import React from 'react';

import { isEmpty } from 'lodash';
import { ReactComponent as VideoIcon } from './icons/Video.svg';
import { ReactComponent as HelpCentreIcon } from './icons/HelpCentre.svg';
import { ReactComponent as ReportProbIcon } from './icons/ReportProb.svg';
import { ReactComponent as WhatsNewIcon } from './icons/WhatsNew.svg';
import { CONTACT_SUPPORT_LINK, HELP_DESK_LINK, RELEASE_NOTES_LINK } from 'js/constants/config';
import { ROUTE_SUPPORT_VIDEOS } from 'js/constants/pathnames';
import { Button } from 'new/elements/Button';

function ContextualSupportLinks(props) {
  return (
    <div className="support-links">
      <Button
        variant="outlined"
        color="inherit"
        className="link-button"
        href={ROUTE_SUPPORT_VIDEOS}
        target="_blank"
        rel="noopener noreferrer"
        startIcon={<VideoIcon />}
      >
        Video tutorials
      </Button>
      <Button
        variant="outlined"
        color="inherit"
        className="link-button"
        component="a"
        href={HELP_DESK_LINK}
        target="_blank"
        rel="noopener noreferrer"
        startIcon={<HelpCentreIcon />}
      >
        Nexla Docs Hub
      </Button>
      {!isEmpty(CONTACT_SUPPORT_LINK) && (
        <Button
          variant="outlined"
          color="inherit"
          className="link-button"
          component="a"
          href={CONTACT_SUPPORT_LINK}
          target="_blank"
          rel="noopener noreferrer"
          startIcon={<ReportProbIcon />}
        >
          Report a problem
        </Button>
      )}
      {!isEmpty(RELEASE_NOTES_LINK) && (
        <Button
          variant="outlined"
          color="inherit"
          className="link-button"
          onClick={() => props.toggleWhatsNew(true)}
          target="#"
          rel="noopener noreferrer"
          startIcon={<WhatsNewIcon />}
        >
          What's new
        </Button>
      )}
    </div>
  );
}

export default ContextualSupportLinks;
